let timeout = null;

/**
 * Load asynchronously the list of contacts from the API
 * @param {Function} complete The callback to execute once the contacts have been loaded
 */
function loadATLContacts() {
    $('#client_code').on('input', function () { setTimeoutToRequest(this) });
    $('#payee_code').on('input', function () { setTimeoutToRequest(this) });
}

function setTimeoutToRequest(source) {
    // cancel previous request
    clearTimeout(timeout);

    // Make a new timeout set to trigger request in 300ms if no more typing occurs
    timeout = setTimeout(function () {
        findContacts(source.value)
    }, 300);
}

function findContacts(payee_code) {
    if (payee_code) {
        $("#contacts-list").html("Loading...");
        $.ajax({
            type: "GET",
            url: getApiURL("contacts"),
            headers: { "Token": $.cookie('token_api') },
            data: {
                payee_code: payee_code,
                limit: 999
            },
            dataType: "json",
            success: function (contacts) {
                let contactsList = '';
                contacts.forEach(contact => {
                    contactsList += `<li>${contact.payee_code}, ${contact.company}, ${contact.street_address}${contact.comment ? ", " + $contact.comment : ""}</li>`;
                });
                $("#contacts-list").html(contactsList);
            },
            error: function (request, textStatus, errorThrown) {
                alert("Something went wrong: \n" + getAjaxErrorMessage(request, errorThrown));
            }
        });
    }
    else { // no text entered
        $("#contacts-list").html("");
    }
};